<template>
  <v-app id="inspire">
    <AppBar />
    <div class="zalo-page">
      <vh-zalo-inbox :api-base="apiBase" :socket-base="socketBase" :token="token" />
    </div>
  </v-app>
</template>

<script>
import AppBar from '../baseComponents/AppBar.vue'
import VhZaloInbox from '../components/Zalo/ZaloInbox.vue'
import TokenService from '../helpers/token'

export default {
  name: 'ZaloChat',
  components: { AppBar, VhZaloInbox },
  computed: {
    token() {
      return this.$store.state.token || TokenService.getToken() || ''
    },
    apiBase() {
      const configured = process.env.VUE_APP_ZALO_API || ''
      return String(configured).replace(/\/$/, '').replace(/\/api\/v1$/, '')
    },
    socketBase() {
      return process.env.VUE_APP_ZALO_SOCKET || 'https://rinochat-socket.rinoedu.ai'
    },
  },
}
</script>

<style scoped>
.zalo-page {
  height: calc(100vh - 72px);
  margin-top: 72px;
}
</style>
